import HomeComponent from '../components/home'

function Home() {

    return(
        <>
        <HomeComponent/>
        </>
    )
}
export default Home